<template>
  <div class="test-view cp3-new-7-dec">
    <div v-if="questions.length > 0">
      <div
        v-for="currentQuestion in questions"
        :key="currentQuestion.id"
        class="test-page-section cp3-bucket-que-section"
        ref="testView"
      >
        <div class="cp3-question-bucket">
          <v-card class="mx-auto normal-card live-test-hg" ref="testBlock">
            <pinch-zoom
              class="pinch-zoom"
              disableZoomControl="disable"
              :wheel="false"
            >
              <div class="tst-quection-block" ref="questionBox">
                <div v-if="questionTypes">
                  <div class="privew-test-bk">
                    <Comprehension
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.COMPREHENSION ||
                          currentQuestion.question_type == questionTypes.TC
                      "
                    />
                    <SingleAnsQuePrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="isPreview"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SINGLE_CORRECT ||
                          currentQuestion.question_type ==
                            questionTypes.ASSERTION_REASON ||  currentQuestion.question_type == questionTypes.SINGLE_CORRECT_SEC2
                      "
                    />
                    <MultipleCorrectPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MULTIPLE_CORRECT
                      "
                    />
                    <IntegerPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type == questionTypes.INTEGER
                      "
                    />
                    <SubjectivePrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="data.isPreview"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SUBJECTIVE ||
                          currentQuestion.question_type ==
                          questionTypes.SUBJECTIVEINTEGER
                      "
                    />
                    <MatrixMatchPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH
                      "
                    />

                    <MatrixMatchOptionPrivew
                      :showAnswerField="showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                      "
                    />
                  </div>
                </div>
              </div>
            </pinch-zoom>
            <div class="save-and-next-btn btn-last-report">
              <v-btn
                color="primary"
                @click="openReportErrorDialog(currentQuestion)"
                class="cust-btn margin-r"
              >
                Report Error
              </v-btn>
              <div class="btn-align">
              <v-btn
                class="current-question-info views-btn"
              >
                 <span class="view-week"> <b>{{currentQuestion.question_view_count || 0}}</b> Views in <br> Last 2 Weeks</span>
              </v-btn>
              <v-btn
                class="current-question-info last-created-btn"
              >
                       <span class="last-info">Last Used <br> <strong> {{currentQuestion.last_created_at ?  currentQuestion.last_created_at : 'NEVER'}} </strong></span>
              </v-btn>
              <v-btn
                v-if="!currentQuestion.is_bucket_question"
                color="primary"
				:disabled="isEditable"
                @click="addQuestionToBucket(currentQuestion)"
                class="cust-btn right-align"
              >
                Add</v-btn
              >
              <v-btn
                v-else
				:disabled="isEditable"
                color="danger"
                @click="removeQuestionFromBucket(currentQuestion)"
                class="cust-btn right-align active"
              >
                Remove</v-btn
              >
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <div class="no-internet" v-else>
      <h4>
        No Questions are available in Bucket
      </h4>
    </div>
    <AlertBox
      :width="modalWidth"
      :onClose="onCloseReport"
      component="components/student/Tests/PastTests/ReportError"
      :status="open"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import isMobile from "is-mobile";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPreview from "@/components/PreviewTest/LegendsPreview.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

// importing components for edit mode
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import TC from "@/components/QuestionType/TC.vue";
// importing axios to cancel heartbeat request if it is pending state till the next heartbeat is called
import axios from "axios";
import constants from "@/utils/constants.js";
export default {
  name: "QuestionBucket",
  props: ["onClose", "status", "data", "onCustomizeClick"],
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPreview,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,

    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC,
    dummyOptionsPQR: [],
    dummyOptions: [],
    dummyOptionsABC: [],
    Carousel,
    Slide,
  },
  async mounted() {
		  this.callApi = false

    this.dummyOptions = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        correct_answer: true,
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[2],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[3],
        option_text: "",
        correct_answer: false,
      },
    ];
    this.dummyOptionsABC = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        column: 1,
        correct_answer: "P",
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        column: 1,
        correct_answer: "P",
      },
    ];
    this.dummyOptionsPQR = [
      {
        index: this.OPTIONS_PQR[0],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_PQR[1],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
    ];
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.getQuestionBucket();
    // this.setIsPastTest(false);
    // await this.setCustomData();
    // this.reverseQuestionsType();
    // this.requestGetTestDetails();
    // this.renderMath();
  },
  data() {
    return {
      isPastTest: false,
      is_preview: true,
      modalWidth: null,
      showAnswerField: true,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {},
      open: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questions: [],
	  isEditable:this.data.isEditable,
	  callApi:false,
    isPreview:""
    };
  },

  watch: {
    data(oldVal, newVal) {
      if (oldVal.question.id !== newVal.question.id || oldVal.isCallBucketApi) {
        this.getQuestionBucket();
		this.isEditable = this.data.isEditable
      }
    },
	status(val){
		if (val==false) {
			let count = 0
			this.questions.map((q) => {
				if (q.is_bucket_question) {
					count = count + 1;
				}
			});
			this.onClose({ status: val, count: count, callApi:this.callApi });
		}
		else{
			this.callApi = false

		}
	}
  },
  methods: {
    ...mapActions({
      getBucketQuestion: "testStore/getBucketQuestion",
      addBucketQuestion: "testStore/addBucketQuestion",
      removeBucketQuestion: "testStore/removeBucketQuestion",
    }),
    onCloseReport(data) {
      this.open = data.status;
    },
    getQuestionBucket() {
		this.questions = [];
    this.$root.showLoader = true;
      let reqData = {
        test_detail_id: this.data.question.test_detail_id,
        target_exam: this.data.question.target_exam,
        required_question_details: true,
        question_type: this.data.question.question_type,
        difficulty_level: this.data.question.difficulty_level,
        topic_id: this.data.question.topic_id,
        test_id: this.data.question.test_id
        // subtopic_id: this.data.question.subtopic_id,
        // concept_id: this.data.question.concept_id,
        // answer_type: this.data.question.answer_type
      };
      if (this.data.question.subtype) {
        reqData.subType = this.data.question.subtype;
      }
      this.getBucketQuestion(reqData)
        .then((response) => {
          this.testDetails = response;
          this.separateQuestions(response.list);
          this.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$root.showLoader = false;
        });
    },
    openReportErrorDialog(currentQuestion) {
      this.alertBoxData = {
        question: currentQuestion,
        errorDescription: "",
      };
      this.modalWidth = "1000px";
      this.open = true;
      this.cComponent = "components/student/Tests/PastTests/ReportError";
      this.$forceUpdate();
    },
    addQuestionToBucket(question) {
      this.open = false;
      const reqData = {
        question_id: question.id,
        test_detail_id: this.data.question.test_detail_id,
      };
      this.addBucketQuestion(reqData)
        .then((response) => {
          // console.log(response);
		  this.callApi = true
          this.changeAddButtonStatus(question);
          // this.getQuestionBucket();
          // this.onClose({ reload: true, status: true });
        })
        .catch((err) => {
          console.log(err);
          // this.onClose({ reload: true, status: true });
        });
    },
    removeQuestionFromBucket(question) {
      this.open = false;

      const reqData = {
        question_id: question.id,
        test_detail_id: this.data.question.test_detail_id,
      };
      this.removeBucketQuestion(reqData)
        .then((response) => {
          // this.getQuestionBucket();
		  this.callApi = true
          this.changeAddButtonStatus(question);

          // this.onClose({ reload: true, status: true });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async separateQuestions(question) {
      let questions = question;
      // questions.sort(this.compare);
      let fql = {}; // filteredQuestionsList
      let subjectQuestionTypeList = {}; // for showing subject - section list
      //this.$root.showLoader = true;

      for (let i = 0; i < questions.length; i++) {
        let questionTypeId = 0;
        let questionTypeName = "";
        let q = null; // question
        let currentQuestionType = null; // current question in particular subject
        let subjectName = null; // current subject
        let subjectId = null; // current subject
        let subjectQuestionTypeObj = {};
        let questionId = 0;

        q = questions[i];
        questionId = q.id;
        questionTypeId = q.questiontype ? q.questiontype.id : q.question_type;
        questionTypeName = q.questiontype ? q.questiontype.value : "";
      }
      await this.generateQuestionsList(question);
    },
    //     setCurrentQuestionData(typeIndex, questionIndex) {
    //       this.setSelectedSQTIndex(typeIndex);
    //     },
    async generateQuestionsList(question) {
      let ql = question;
      let currentQuestion = {};
      let questionsList = [];

      for (let i = 0; i < ql.length; i++) {
        const q = ql[i]; // current question in loop
        let questionTypeId = q.question_type;
        questionTypeId =
          questionTypeId == this.questionTypes.COMPREHENSION ||
          questionTypeId == this.questionTypes.TC
            ? q.subtype.id ?q.subtype.id :q.subtype
            : q.question_type;
        let currentQuestion = {};
        currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
        if (
          q.question_type == this.questionTypes.COMPREHENSION ||
          q.question_type == this.questionTypes.TC
        ) {
          currentQuestion.passage = q.passage;
        }
        currentQuestion = this.getCurrentQuestionCommonKeys(
          currentQuestion,
          q,
          i
        );
        questionsList.push(currentQuestion);
      }
      this.questions = questionsList;
    },
    getCurrentQuestionCommonKeys(currentQuestion, q, index) {
      currentQuestion.id = q.id;
      currentQuestion.questionNo = q.index || this.data.question.questionNo;
      currentQuestion.suggestions = index + 1;
      currentQuestion.is_bucket_question = q.is_bucket_question;
      currentQuestion.question_text = q.question_text;
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.hints = q.hints;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
      currentQuestion.isAnswered = false; // to know if the current question is answered.
      currentQuestion.disabled = false; // disabled in case of preview test
      currentQuestion.isPreview = this.data.isPreview; // disabled in case of preview test
      currentQuestion.institute_id = q.institute_id;
      currentQuestion.question_view_count = q.question_view_count;
      currentQuestion.last_created_at = q.last_created_at ?  moment(q.last_created_at).format(constants.DATE_FORMATS.DISPLAY_DATE):null;
 
      if (this.data.isPreview) {
        currentQuestion.status = this.questionStatus.ANSWER_SELECTED_SAVED; // "status" along with "isAnswered" will be used for loading legends & pallet info
        currentQuestion.isAnswered = this.data.isPreview; // to know if the current question is answered.
        currentQuestion.disabled = this.data.isPreview; // disabled in case of preview test
      }
      if (q.user_selected_answer && !this.data.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        currentQuestion.isAnswered = answer.answer ? true : false;
        currentQuestion.status = answer.status;
      }

      return currentQuestion;
    },
    checkIfAnswered(type, q) {
      let option = null;
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        q.status = answer.status;
        let options = q.options.map((o) => {
          return { ...o, ...{ correct_answer: false } };
        });
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
            this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) option.correct_answer = true;
              break;

            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) option.correct_answer = true;
              });
              break;
          }
        }
        return options;
      } else return q.options;
    },
    generateQuestionObject(typeId, q) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      currentQuestion.chapterId = q.data_type_id;
      currentQuestion.chapterName = q.datatype ? q.datatype.title : "";
      currentQuestion.dataType = q.datatype;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.difficulty = q.difficulty;
      currentQuestion.difficulty_level = q.difficulty_level || null;
      currentQuestion.time = q.time;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.topicName = q.topic ? q.topic.title : "";
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      switch (type) {
        case 1:
          currentQuestion.options = this.checkIfAnswered(typeId, q);
          break;
        case 2:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = parseInt(answer.answer);
          } else {
            currentQuestion.correct_answer = null;
          }
          break;
        case 3:
          let matrixOptions = this.separateOptions(q, 1);
          currentQuestion.options_abc = matrixOptions.options_abc;
          currentQuestion.options_pqr = matrixOptions.options_pqr;
          break;
        case 4:
          let options = this.separateOptions(q, 2);
          currentQuestion.options_abc = options.options_abc;
          currentQuestion.options_pqr = options.options_pqr;
          currentQuestion.options = options.op;
          break;
        case 6:
          if (this.data.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = answer.answer;
          } else {
            currentQuestion.correct_answer = "";
          }
          let subjectiveAnswers = this.getSubjectiveAnswers(
            currentQuestion.correct_answer,
            q
          );
          currentQuestion.startValue = subjectiveAnswers.startValue;
          currentQuestion.endValue = subjectiveAnswers.endValue;
          break;
      }
      return currentQuestion;
    },
    getQuestionType(id) {
      if (
        id == this.questionTypes.ASSERTION_REASON ||
        id == this.questionTypes.MULTIPLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
        id == this.questionTypes.COMPREHENSION_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MM ||
        id == this.questionTypes.COMPREHENSION_2Q_MA ||
        id == this.questionTypes.COMPREHENSION_3Q_SA ||
        id == this.questionTypes.COMPREHENSION_3Q_MA ||
        id == this.questionTypes.TC_2Q_SA ||
        id == this.questionTypes.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.questionTypes.INTEGER) {
        return 2;
      } else if (id == this.questionTypes.MATRIX_MATCH) {
        return 3;
      } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (id == this.questionTypes.COMPREHENSION) {
        return 5;
      } else if (id == this.questionTypes.SUBJECTIVE ||
        id == this.questionTypes.COMPREHENSION_2Q_NU ||
        id == this.questionTypes.SUBJECTIVEINTEGER) {
        return 6;
      }
    },
    getSubjectiveAnswers(answer, q) {
      let separatedAnswer = {
        startValue: null,
        endValue: null,
      };
      if (answer > "" && this.data.isPreview) {
        let answerArray = answer.split("##");
        if (answerArray.length == 2) {
          separatedAnswer.startValue = answerArray[0];
          separatedAnswer.endValue = answerArray[1];
        } else if (answerArray.length == 1) {
          separatedAnswer.startValue = answerArray[0];
        }
      } else if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        if (
          answer.answer &&
          !answer.answer.startValue &&
          !answer.answer.endValue
        ) {
          separatedAnswer.correct_answer = parseInt(answer.answer);
        }
      }
      return separatedAnswer;
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      options.forEach((option) => {
        if (option.column == 1) {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : false;
          // option.correct_answer = false;
          op.push(option);
        }
      });
      if (type == 1) {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map((a) => {
              let option = options_abc.find((o) => o.id == a.option_id);
              if (option) {
                option.correct_answer = a.value;
              }
            });
          }
        }
      } else {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find((o) => o.id == answer.answer.option_id);
            if (option) {
              option.correct_answer = true;
            }
          }
        }
      }

      return {
        op,
        options_abc,
        options_pqr,
      };
    },
    changeAddButtonStatus(question) {
      let count = 0;
      const index = this.questions.findIndex((q) => q.id === question.id);
      this.questions[index].is_bucket_question = !this.questions[index]
        .is_bucket_question;
      this.questions.map((q) => {
        if (q.is_bucket_question) {
          count = count + 1;
        }
      });
      this.onClose({ status: true, count: count });
    },
  },
};
</script>
